import { render, staticRenderFns } from "./IncomeTypeForm.vue?vue&type=template&id=1d379030"
import script from "./IncomeTypeForm.vue?vue&type=script&lang=js"
export * from "./IncomeTypeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports